import { ClientDetailsModel } from 'types/ClientDetailsModel';
import { http } from '../http';

export const getClientData = async (
  commercialLabel: string,
  loanNumber: number
): Promise<ClientDetailsModel> => {
  const response = await http.get(`/api/v1/clients/${commercialLabel}/${loanNumber}/loandata`);
  return response.data;
};
